import { ActionButton, Cell } from './Table.styled';

export const ACTION_CELL_TEXT = {
  buttonText: 'Copy to all projects',
};

export const ActionCell = ({ onClick }: { onClick: () => void }) => {
  return (
    <Cell>
      <ActionButton onClick={onClick} type="button">
        {ACTION_CELL_TEXT.buttonText}
      </ActionButton>
    </Cell>
  );
};
